import { render, staticRenderFns } from "./AlertsByCustomerWidget.vue?vue&type=template&id=2885a9fb&scoped=true&"
import script from "./AlertsByCustomerWidget.vue?vue&type=script&lang=js&"
export * from "./AlertsByCustomerWidget.vue?vue&type=script&lang=js&"
import style0 from "./AlertsByCustomerWidget.vue?vue&type=style&index=0&id=2885a9fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885a9fb",
  null
  
)

export default component.exports